import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/loader/Loadable';
import UserReactTable from '../views/tables/UserReactTable';
import ProjectDetails from '../views/tables/ProjectDetails';
import VendorTable from '../views/tables/VendorTable';
import ProjectAdmin from '../views/tables/ProjectAdmin';
import PendingSites from '../views/tables/PendingSites';
import ProjectAdminDetails from '../views/tables/ProjectAdminDetails';
import NodalAgency from '../views/tables/NodalAgency';
import NodalProjectDetails from '../views/tables/NodalProjectDetails';
import NodalAgencyPending from '../views/tables/NodalAgencyPending';
import CityHeadTable from '../views/tables/CityHeadTable';
import CityHeadProjectDetails from '../views/tables/CityHeadProjectDetails';
import CityHeadPendingProject from '../views/tables/CityHeadPendingProject';
import RmhTables from '../views/tables/RmhTable';
import RmhPendingProject from '../views/tables/RmhPendingProject';
import RmhProjectDetails from '../views/tables/RmhProjectDetails';
import DataUpload from '../views/tables/DataUpload';
import OldProjects from '../views/tables/OldProjects';
import OldProjectDetails from '../views/tables/OldProjectDetails';
import OldSalesOverview from '../components/dashboard/minimalDashboard/OldSalesOverview';
import StateHeadOldProject from '../views/tables/StateHeadOldProject';
import StateHeadOldProjectDetails from '../views/tables/StateHeadOldProjectDetails';
import StateHeadOldProjectPending from '../views/tables/StateHeadOldProjectPending';
import VendorOldProject from '../views/tables/VendorOldProject';
import VendorOldDetailsProject from '../views/tables/VendorOldDetailsProject';
import ScamProjectDetails from '../views/tables/ScamProjectDetails';
import AirtelPaymentVendor from '../views/tables/AirtelPaymentVendor';
import AirtelPaymentVendorDetail from '../views/tables/AirtelPaymentVendorDetail';
import AirtelPaymentVendorPending from '../views/tables/AirtelPaymentVendorPending';
import AirtelPaymentSummury from '../components/dashboard/minimalDashboard/AirtelPaymentSummary';
import AirtelPaymentBankStateHead from '../views/tables/AirtelPaymentBankStateHead';
import AirtelPaymentBankStateHeadPending from '../views/tables/AirtelPaymentBankStateHeadPending';
import AirtelPaymentBankClient from '../views/tables/AirtelPaymentBankClient';
import AirtelPaymentImageUpload from '../views/tables/AirtelPaymentImageUpload';
import AirtelPaymentAdminDetail from '../views/tables/AirtelPaymentAdminDetail';
import AirtelPaymentBankClientDetail from '../views/tables/AirtelPaymentBankClientDetail';
import AirtelPaymentBankStateHeadDetail from '../views/tables/AirtelPaymentBankStateHeadDetail';
import AirtelPaymentClienStateheadPending from '../views/tables/AirtelPaymentClienStateheadPending';
import AirtelPaymentPendingSites from '../views/tables/AirtelPaymentPendingSites';
import MpcgVendor from '../views/tables/mpcg/MpcgVendor';
import Mpcgsummary from '../components/dashboard/minimalDashboard/Mpcgsummary';
import AirtelMpcgVendorDetail from '../views/tables/mpcg/AirtelMpcgVendorDetail';
import AirtelmpcgVendorPending from '../views/tables/mpcg/AirtelmpcgVendorPending';
import AirtelmpcgsStateHead from '../views/tables/mpcg/AirtelmpcgsStateHead';
import AirtelMpcgStateHeadPending from '../views/tables/mpcg/AirtelMpcgStateHeadPending';
import AirtelMpcgStateHeadDetail from '../views/tables/mpcg/AirtelMpcgStateHeadDetail';
import Upesummary from '../components/dashboard/minimalDashboard/Upesummary';
import UpeVendor from '../views/tables/upe/UpeVendor';
import AirtelupeStateHead from '../views/tables/upe/AirtelupeStateHead';
import AirtelUpeVendorDetail from '../views/tables/upe/AirtelUpeVendorDetail';
import AirtelUpeStateHeadPending from '../views/tables/upe/AirtelUpeStateHeadPending';
import AirtelUpeVendorPending from '../views/tables/upe/AirtelUpeVendorPending';
import AirtelUpeStateHeadDetail from '../views/tables/upe/AirtelUpeStateHeadDetail';
import AdobeSummary from '../components/dashboard/minimalDashboard/AdobeSummary';
import AdobeVendor from '../views/tables/upe/AdobeVendor';
import AirtelAdobeVendorDetail from '../views/tables/upe/AirtelAdobeVendorDetail';
import AirtelAdobeVendorPending from '../views/tables/upe/AirtelAdobeVendorPending';
import AirtelAdobeStateHead from '../views/tables/upe/AirtelAdobeStateHead';
import AirtelAdobeStateHeadDetail from '../views/tables/upe/AirtelAdobeStateHeadDetail';
import AirtelAdobeStateHeadPending from '../views/tables/upe/AirtelAdobeStateHeadPending';
import MasterSummary from '../components/dashboard/minimalDashboard/MasterSummary';
import MasterbrandVendor from '../views/tables/upe/MasterbrandVendor';
import MasterbrandVendorDetail from '../views/tables/upe/MasterbrandVendorDetail';
import MasterbrandVendorPending from '../views/tables/upe/MasterbrandVendorPending';
import MasterbrandStateHead from '../views/tables/upe/MasterbrandStateHead';
import MasterbrandStateHeadPending from '../views/tables/upe/MasterbrandStateHeadPending';
import MasterbrandStateHeadDetail from '../views/tables/upe/MasterbrandStateHeadDetail';
import UploadImages from '../views/tables/UploadImages';
/****Layouts*****/

const FullLayout = Loadable(lazy(() => import('../layouts/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/BlankLayout')));
/***** Pages ****/

const Minimal = Loadable(lazy(() => import('../views/dashboards/Minimal')));
const Analytical = Loadable(lazy(() => import('../views/dashboards/Analytical')));
const Demographical = Loadable(lazy(() => import('../views/dashboards/Demographical')));
const Modern = Loadable(lazy(() => import('../views/dashboards/Modern')));

/***** Apps ****/
const Notes = Loadable(lazy(() => import('../views/apps/notes/Notes')));
const Chat = Loadable(lazy(() => import('../views/apps/chat/Chat')));
const Contacts = Loadable(lazy(() => import('../views/apps/contacts/Contacts')));
const Calendar = Loadable(lazy(() => import('../views/apps/calendar/CalendarApp')));
const Email = Loadable(lazy(() => import('../views/apps/email/Email')));
const Shop = Loadable(lazy(() => import('../views/apps/ecommerce/Shop')));
const ShopDetail = Loadable(lazy(() => import('../views/apps/ecommerce/ShopDetail')));
const Treeview = Loadable(lazy(() => import('../views/apps/treeview/TreeView')));
const TicketList = Loadable(lazy(() => import('../views/apps/ticket/TicketList')));
const TicketDetail = Loadable(lazy(() => import('../views/apps/ticket/TicketDetail')));

/***** Ui Elements ****/
const Alerts = Loadable(lazy(() => import('../views/ui/Alerts')));
const Badges = Loadable(lazy(() => import('../views/ui/Badges')));
const Buttons = Loadable(lazy(() => import('../views/ui/Buttons')));
const Cards = Loadable(lazy(() => import('../views/ui/Cards')));
const Grid = Loadable(lazy(() => import('../views/ui/Grid')));
const Tables = Loadable(lazy(() => import('../views/ui/Tables')));
const Forms = Loadable(lazy(() => import('../views/ui/Forms')));
const Breadcrumbs = Loadable(lazy(() => import('../views/ui/Breadcrumbs')));
const Dropdowns = Loadable(lazy(() => import('../views/ui/DropDown')));
const BtnGroup = Loadable(lazy(() => import('../views/ui/BtnGroup')));
const Collapse = Loadable(lazy(() => import('../views/ui/Collapse')));
const ListGroup = Loadable(lazy(() => import('../views/ui/ListGroup')));
const Modal = Loadable(lazy(() => import('../views/ui/Modal')));
const Navbar = Loadable(lazy(() => import('../views/ui/Navbar')));
const Nav = Loadable(lazy(() => import('../views/ui/Nav')));
const Pagination = Loadable(lazy(() => import('../views/ui/Pagination')));
const Popover = Loadable(lazy(() => import('../views/ui/Popover')));
const Progress = Loadable(lazy(() => import('../views/ui/Progress')));
const Spinner = Loadable(lazy(() => import('../views/ui/Spinner')));
const Tabs = Loadable(lazy(() => import('../views/ui/Tabs')));
const Toasts = Loadable(lazy(() => import('../views/ui/Toasts')));
const Tooltip = Loadable(lazy(() => import('../views/ui/Tooltip')));

/***** Form Layout Pages ****/
const FormBasic = Loadable(lazy(() => import('../views/form-layouts/FormBasic')));
const FormGrid = Loadable(lazy(() => import('../views/form-layouts/FormGrid')));
const FormGroup = Loadable(lazy(() => import('../views/form-layouts/FormGroup')));
const FormInput = Loadable(lazy(() => import('../views/form-layouts/FormInput')));

/***** Form Pickers Pages ****/
const Datepicker = Loadable(lazy(() => import('../views/form-pickers/DateTimePicker')));
const TagSelect = Loadable(lazy(() => import('../views/form-pickers/TagSelect')));

/***** Form Validation Pages ****/
const FormValidate = Loadable(lazy(() => import('../views/form-validation/FormValidation')));
const FormSteps = Loadable(lazy(() => import('../views/form-steps/Steps')));
const FormEditor = Loadable(lazy(() => import('../views/form-editor/FormEditor')));
/***** Table Pages ****/
const Basictable = Loadable(lazy(() => import('../views/tables/TableBasic')));
const CustomReactTable = Loadable(lazy(() => import('../views/tables/CustomReactTable')));
const ReactBootstrapTable = Loadable(lazy(() => import('../views/tables/ReactBootstrapTable')));
const UserTableDetails = Loadable(lazy(() => import('../views/tables/UserTableDetails')));

/***** Chart Pages ****/
const ApexCharts = Loadable(lazy(() => import('../views/charts/ApexCharts')));
const ChartJs = Loadable(lazy(() => import('../views/charts/ChartJs')));

/***** Sample Pages ****/
const StarterKit = Loadable(lazy(() => import('../views/sample-pages/StarterKit')));
const Profile = Loadable(lazy(() => import('../views/sample-pages/Profile')));
const Gallery = Loadable(lazy(() => import('../views/sample-pages/Gallery')));
const SearchResult = Loadable(lazy(() => import('../views/sample-pages/SearchResult')));
const HelperClass = Loadable(lazy(() => import('../views/sample-pages/HelperClass')));

/***** Icon Pages ****/
const Bootstrap = Loadable(lazy(() => import('../views/icons/Bootstrap')));
const Feather = Loadable(lazy(() => import('../views/icons/Feather')));

/***** Map Pages ****/
const CustomVectorMap = Loadable(lazy(() => import('../views/maps/CustomVectorMap')));

/***** Widget Pages ****/
const Widget = Loadable(lazy(() => import('../views/widget/Widget')));

/***** CASL Access Control ****/
const CASL = Loadable(lazy(() => import('../views/apps/accessControlCASL/AccessControl')));

/***** Auth Pages ****/
const Error = Loadable(lazy(() => import('../views/auth/Error')));
const RegisterFormik = Loadable(lazy(() => import('../views/auth/RegisterFormik')));
const LoginFormik = Loadable(lazy(() => import('../views/auth/LoginFormik')));
const Maintanance = Loadable(lazy(() => import('../views/auth/Maintanance')));
const LockScreen = Loadable(lazy(() => import('../views/auth/LockScreen')));
const RecoverPassword = Loadable(lazy(() => import('../views/auth/RecoverPassword')));

/*****Routes******/

const ThemeRoutes = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', name: 'Login', element: <Navigate to="/auth/loginformik" /> },

      { path: '/home', name: 'Home', element: <Navigate to="/tables/vendor-honda-campign" /> },
      { path: '/dashboards/minimal', name: 'Minimal', exact: true, element: <Minimal /> },
      { path: '/old/project/summary', name: 'Scam campaign summary', exact: true, element: <OldSalesOverview /> },
      { path: '/dashboards/analytical', name: 'Analytical', exact: true, element: <Analytical /> },
      { path: '/dashboards/demographical', name: 'Demographical', exact: true, element: <Demographical /> },
      { path: '/dashboards/modern', name: 'Modern', exact: true, element: <Modern /> },
      { path: '/apps/notes', name: 'notes', exact: true, element: <Notes /> },
      { path: '/apps/chat', name: 'chat', exact: true, element: <Chat /> },
      { path: '/apps/contacts', name: 'contacts', exact: true, element: <Contacts /> },
      { path: '/apps/calendar', name: 'calendar', exact: true, element: <Calendar /> },
      { path: '/apps/email', name: 'email', exact: true, element: <Email /> },
      { path: '/ecom/shop', name: 'email', exact: true, element: <Shop /> },
      { path: '/ecom/shopdetail', name: 'email', exact: true, element: <ShopDetail /> },
      { path: '/tickt/ticket-list', name: 'ticket list', exact: true, element: <TicketList /> },
      {
        path: '/tickt/ticket-detail',
        name: 'ticket detail',
        exact: true,
        element: <TicketDetail />,
      },
      { path: '/dashboards/airtel-payment-summary', name: 'email', exact: true, element: <AirtelPaymentSummury /> },
      { path: '/dashboards/mpcg-summary', name: 'email', exact: true, element: <Mpcgsummary /> },
      { path: '/dashboards/upe-summary', name: 'email', exact: true, element: <Upesummary /> },
      { path: '/dashboards/honda-summary', name: 'email', exact: true, element: <AdobeSummary /> },
      { path: '/dashboards/honda-summary', name: 'email', exact: true, element: <MasterSummary /> },
      { path: '/apps/treeview', name: 'email', exact: true, element: <Treeview /> },
      { path: '/ui/alerts', name: 'alerts', exact: true, element: <Alerts /> },
      { path: '/ui/badges', name: 'badges', exact: true, element: <Badges /> },
      { path: '/ui/buttons', name: 'buttons', exact: true, element: <Buttons /> },
      { path: '/ui/cards', name: 'cards', exact: true, element: <Cards /> },
      { path: '/ui/grid', name: 'grid', exact: true, element: <Grid /> },
      { path: '/ui/table', name: 'table', exact: true, element: <Tables /> },
      { path: '/ui/forms', name: 'forms', exact: true, element: <Forms /> },
      { path: '/ui/breadcrumbs', name: 'breadcrumbs', exact: true, element: <Breadcrumbs /> },
      { path: '/ui/dropdown', name: 'dropdown', exact: true, element: <Dropdowns /> },
      { path: '/ui/button-group', name: 'button group', exact: true, element: <BtnGroup /> },
      { path: '/ui/collapse', name: 'collapse', exact: true, element: <Collapse /> },
      { path: '/ui/list-group', name: 'list-group', exact: true, element: <ListGroup /> },
      { path: '/ui/modal', name: 'modal', exact: true, element: <Modal /> },
      { path: '/ui/navbar', name: 'navbar', exact: true, element: <Navbar /> },
      { path: '/ui/nav', name: 'nav', exact: true, element: <Nav /> },
      { path: '/ui/pagination', name: 'pagination', exact: true, element: <Pagination /> },
      { path: '/ui/popover', name: 'popover', exact: true, element: <Popover /> },
      { path: '/ui/progress', name: 'progress', exact: true, element: <Progress /> },
      { path: '/ui/spinner', name: 'spinner', exact: true, element: <Spinner /> },
      { path: '/ui/tabs', name: 'tabs', exact: true, element: <Tabs /> },
      { path: '/ui/toasts', name: 'toasts', exact: true, element: <Toasts /> },
      { path: '/ui/tooltip', name: 'tooltip', exact: true, element: <Tooltip /> },
      { path: '/form-layout/form-basic', name: 'form-basic', exact: true, element: <FormBasic /> },
      { path: '/form-layout/form-grid', name: 'form-grid', exact: true, element: <FormGrid /> },
      { path: '/form-layout/form-group', name: 'form-group', exact: true, element: <FormGroup /> },
      { path: '/form-layout/form-input', name: 'form-input', exact: true, element: <FormInput /> },
      {
        path: '/form-pickers/datepicker',
        name: 'datepicker',
        exact: true,
        element: <Datepicker />,
      },
      { path: '/form-pickers/tag-select', name: 'tag-select', exact: true, element: <TagSelect /> },
      { path: '/form-validation', name: 'form-validation', exact: true, element: <FormValidate /> },
      { path: '/form-steps', name: 'form-steps', exact: true, element: <FormSteps /> },
      { path: '/form-editor', name: 'form-editor', exact: true, element: <FormEditor /> },

      { path: '/tables/basic-table', name: 'basic-table', exact: true, element: <Basictable /> },
      {
        path: '/tables/data-table',
        // name: 'data-table',
        exact: true,
        element: <CustomReactTable />,
      },

      {
        path: '/tables/vendor-table',
        exact: true,
        element: <CityHeadTable />,
      },
         {
        path: '/tables/vendor-table-old',
        exact: true,
        element: <VendorOldProject />,
      },


         {
        path: '/tables/vendor-airtel-payment',
        exact: true,
        element: <AirtelPaymentVendor />,
      },
          {
        path: '/tables/vendor-mpcg-campign',
        exact: true,
        element: <MpcgVendor />,
      },
         {
        path: '/tables/vendor-upe-campign',
        exact: true,
        element: <UpeVendor />,
      },
           {
        path: '/tables/vendor-honda-campign',
        exact: true,
        element: <AdobeVendor />,
      },

          {
        path: '/tables/vendor-masterbrand-campign',
        exact: true,
        element: <MasterbrandVendor />,
      },
           {
        path: '/tables/client-statehead-pending',
        exact: true,
        element: <AirtelPaymentClienStateheadPending />,
      },
        {
        path: '/tables/old-projects',
        exact: true,
        element: <OldProjects />,
      },
        {
        path: '/tables/airtel-payment-bank-campaign-projects',
        exact: true,
        element: <AirtelPaymentBankClient />,
      },
     
       {
        path: '/data-upload',
        exact: true,
        element: <DataUpload />,
      },
      {
        path: '/vendor-detail/:id',
        name: 'vendor-table-details',
        exact: true,
        element: <CityHeadProjectDetails />,
      },
         {
        path: '/airtel-payment-project-detail/:id',
        name: 'vendor-table-details',
        exact: true,
        element: <AirtelPaymentVendorDetail />,
      },
          {
        path: '/airtel-mpcg-project-detail/:id',
        name: 'vendor-table-details',
        exact: true,
        element: <AirtelMpcgVendorDetail />,
      },
         {
        path: '/airtel-upe-project-detail/:id',
        name: 'vendor-table-details',
        exact: true,
        element: <AirtelUpeVendorDetail />,
      },
           {
        path: '/honda-project-detail/:id',
        name: 'vendor-table-details',
        exact: true,
        element: <AirtelAdobeVendorDetail />,
      },
             {
        path: '/honda-cmp-project-detail/:id',
        name: 'vendor-table-details',
        exact: true,
        element: <MasterbrandVendorDetail />,
      },
         {
        path: '/vendor-old-project-detail/:id',
        name: 'vendor-table-details',
        exact: true,
        element: <VendorOldDetailsProject />,
      },

          {
        path: '/scam-project-details/:id',
        name: 'scam-project-details',
        exact: true,
        element: <ScamProjectDetails />,
      },
      {
        path: '/vendor-pending/:id',
        name: 'vendor-pending-table-details',
        exact: true,
        element: <CityHeadPendingProject />,
      },
       {
        path: '/airtel-payment-vendor-pending/:id',
        name: 'vendor-pending-table-details',
        exact: true,
        element: <AirtelPaymentVendorPending />,
      },
          {
        path: '/airtel-mpcg-vendor-pending/:id',
        name: 'vendor-pending-table-details',
        exact: true,
        element: <AirtelmpcgVendorPending />,
      },

          {
        path: '/airtel-upe-vendor-pending/:id',
        name: 'vendor-pending-table-details',
        exact: true,
        element: <AirtelUpeVendorPending />,
      },
           {
        path: '/honda-vendor-pending/:id',
        name: 'vendor-pending-table-details',
        exact: true,
        element: <AirtelAdobeVendorPending />,
      },

            {
        path: '/airtel-masterbrand-vendor-pending/:id',
        name: 'vendor-pending-table-details',
        exact: true,
        element: <MasterbrandVendorPending />,
      },


      {
        path: '/tables/rmh-table',
        exact: true,
        element: <RmhTables />,
      },
        {
        path: '/tables/airtel-payment-bank-statehead-table',
        exact: true,
        element: <AirtelPaymentBankStateHead />,
      },

         {
        path: '/tables/airtel-mpcg-statehead-table',
        exact: true,
        element: <AirtelmpcgsStateHead />,
      },
          {
        path: '/tables/airtel-upe-statehead-table',
        exact: true,
        element: <AirtelupeStateHead />,
      },

         {
        path: '/tables/honda-statehead-table',
        exact: true,
        element: <AirtelAdobeStateHead />,
      },
         {
        path: '/tables/airtel-masterbrand-statehead-table',
        exact: true,
        element: <MasterbrandStateHead />,
      },
         {
        path: '/tables/state-head-table',
        exact: true,
        element: <StateHeadOldProject />,
      },
      {
        path: '/rmh-pending/:id',
        name: 'rmh-pending-project',
        exact: true,
        element: <RmhPendingProject />,
      },
       {
        path: '/airtel-payment-statehead-pending/:id',
        name: 'airtel-payment-statehead-project',
        exact: true,
        element: <AirtelPaymentBankStateHeadPending />,
      },
       {
        path: '/airtel-mpcg-statehead-pending/:id',
        name: 'airtel-payment-statehead-project',
        exact: true,
        element: <AirtelMpcgStateHeadPending />,
      },
        {
        path: '/airtel-upe-statehead-pending/:id',
        name: 'airtel-payment-statehead-project',
        exact: true,
        element: <AirtelUpeStateHeadPending />,
      },
       {
        path: '/honda-statehead-pending/:id',
        name: 'airtel-payment-statehead-project',
        exact: true,
        element: <AirtelAdobeStateHeadPending />,
      },

         {
        path: '/airtel-masterbrand-statehead-pending/:id',
        name: 'airtel-payment-statehead-project',
        exact: true,
        element: <MasterbrandStateHeadPending />,
      },
      {
        path: '/state-head-old-pending/:id',
        name: 'state-head-old-pending',
        exact: true,
        element: <StateHeadOldProjectPending />,
      },
      {
        path: '/rmh-detail/:id',
        name: 'rmh-pending-table-details',
        exact: true,
        element: <RmhProjectDetails />,
      },
      
       {
        path: '/state-head/:id',
        name: 'State-Head-project-Details',
        exact: true,
        element: <StateHeadOldProjectDetails />,
      },

      {
        path: '/vendor-details/:vendorName',
        name: 'vendor-table',
        exact: true,
        element: <VendorTable />,
      },

      {
        path: '/tables/user-table',
        name: 'user table',
        exact: true,
        element: <UserReactTable />,
      },

      {
        path: '/tables/nodal-agency',
        name: 'nodal agency table',
        exact: true,
        element: <NodalAgency />,
      },

      
      {
        path: '/tables/project-admin',
        name: 'user table',
        exact: true,
        element: <ProjectAdmin />,
      },
      {
        path: '/tables/pending-sites',
        name: 'user table',
        exact: true,
        element: <PendingSites />,
      },

       {
        path: '/tables/upload-images',
        name: 'user table',
        exact: true,
        element: <UploadImages />,
      },


        {
        path: '/tables/airtel-payment-pending-sites',
        name: 'user table',
        exact: true,
        element: <AirtelPaymentPendingSites />,
      },
  {
        path: '/tables/airtel-payment-upload-image',
        name: 'user table',
        exact: true,
        element: <AirtelPaymentImageUpload />,
      },
      {
        path: '/user/:id',
        name: 'user-table-details',
        exact: true,
        element: <UserTableDetails />,
      },
      {
        path: '/project-details/:id',
        name: 'user-table-details',
        exact: true,
        element: <ProjectDetails />,
      },
        {
        path: '/old-project-details/:id',
        name: 'user-table-details',
        exact: true,
        element: <OldProjectDetails />,
      },
          {
        path: '/airtel-payment-bank-client-detail/:id',
        name: 'user-table-details',
        exact: true,
        element: <AirtelPaymentBankClientDetail />,
      },
          {
        path: '/airtel-payment-bank-state-head-detail/:id',
        name: 'user-table-details',
        exact: true,
        element: <AirtelPaymentBankStateHeadDetail />,
      },
           {
        path: '/airtel-mpcg-state-head-detail/:id',
        name: 'user-table-details',
        exact: true,
        element: <AirtelMpcgStateHeadDetail />,
      },

         {
        path: '/airtel-upe-state-head-detail/:id',
        name: 'user-table-details',
        exact: true,
        element: <AirtelUpeStateHeadDetail />,
      },
             {
        path: '/honda-state-head-detail/:id',
        name: 'user-table-details',
        exact: true,
        element: <AirtelAdobeStateHeadDetail />,
      },
               {
        path: '/airtel-masterbrand-state-head-detail/:id',
        name: 'user-table-details',
        exact: true,
        element: <MasterbrandStateHeadDetail />,
      },
          {
        path: '/airtel-payment-bank-campaign-projects-details/:id',
        name: 'user-table-details',
        exact: true,
        element: <OldProjectDetails />,
      },

      {
        path: '/nodal-agency-detail/:id',
        name: 'nodal-agency-table-details',
        exact: true,
        element: <NodalProjectDetails />,
      },
      {
        path: '/nodal-agency-pending/:id',
        name: 'nodal-agency-pending-table-details',
        exact: true,
        element: <NodalAgencyPending />,
      },



      {
        path: '/project-admin-details/:sitecode',
        name: 'user-table-details',
        exact: true,
        element: <ProjectAdminDetails />,
      },

         {
        path: '/airtel-payment-admin-details/:sitecode',
        name: 'user-table-details',
        exact: true,
        element: <AirtelPaymentAdminDetail />,
      },
      {
        path: '/tables/datas-table',
        name: 'data-table',
        exact: true,
        element: <ReactBootstrapTable />,
      },
      { path: '/charts/apex', name: 'apex', exact: true, element: <ApexCharts /> },
      { path: '/charts/chartjs', name: 'chartjs', exact: true, element: <ChartJs /> },
      { path: '/sample-pages/profile', name: 'profile', exact: true, element: <Profile /> },
      {
        path: '/sample-pages/helper-class',
        name: 'helper-class',
        exact: true,
        element: <HelperClass />,
      },
      {
        path: '/sample-pages/starterkit',
        name: 'starterkit',
        exact: true,
        element: <StarterKit />,
      },
      { path: '/sample-pages/gallery', name: 'gallery', exact: true, element: <Gallery /> },
      {
        path: '/sample-pages/search-result',
        name: 'search-result',
        exact: true,
        element: <SearchResult />,
      },
      { path: '/icons/bootstrap', name: 'bootstrap', exact: true, element: <Bootstrap /> },
      { path: '/icons/feather', name: 'feather', exact: true, element: <Feather /> },
      { path: '/map/vector', name: 'vector', exact: true, element: <CustomVectorMap /> },
      { path: '/widget', name: 'widget', exact: true, element: <Widget /> },
      { path: '/casl', name: 'casl', exact: true, element: <CASL /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/auth',
    element: <BlankLayout />,
    children: [
      { path: '404', element: <Error /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
      { path: 'registerformik', element: <RegisterFormik /> },
      { path: 'loginformik', element: <LoginFormik /> },
      { path: 'maintanance', element: <Maintanance /> },
      { path: 'lockscreen', element: <LockScreen /> },
      { path: 'recoverpwd', element: <RecoverPassword /> },
    ],
  },
];

export default ThemeRoutes;
